import React from "react";
import ReactDOM from "react-dom";
import { FilterContextProvider } from "./innovants/filters-context";
import Filters from "./innovants/filters";

const filtersApp = () => {
  return (
    <FilterContextProvider>
      <Filters />
    </FilterContextProvider>
  );
};

export const initFilters = () => {
  ReactDOM.render(filtersApp(), document.getElementById("innovant-filters"));
};
